export enum GenericPageTypes {
  "Account" = "Account",
  "Area" = "Area",
  "Competitor" = "Competitor",
  "Contact Type" = "Contact Type",
  "Crew" = "Crew",
  "Customer Type" = "Customer Type",
  "Document" = "Document",
  "Field Technician" = "Field Technician",
  "Item" = "Item",
  "Item Type" = "Item Type",
  "Job Type" = "Job Type",

  "Lead Source" = "Lead Source",
  "Lost Reason" = "Lost Reason",
  "Payment Term" = "Payment Term",
  "Payment Type" = "Payment Type",
  "Quote Template" = "Quote Template",
  "Quote Item Note Template" = "Quote Item Note Template",
  "Resource" = "Resource",
  "Resource Type" = "Resource Type",
  "SubArea" = "SubArea",

  "Vendor Type" = "Vendor Type",
  "Warehouse" = "Warehouse",
  "Warehouse Location" = "Warehouse Location",

  "Work Order Status" = "Work Order Status",
  "Work Order Type" = "Work Order Type",

  "User" = "User",
  "Office" = "Office",
  "Role" = "Role",
  "Vendor" = "Vendor",
}
